
import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';
import styled from 'styled-components';

const HtmlParserContainer = styled.div<{
	padding?: { top?: string; right?: string; bottom?: string; left?: string; },
}>`
	margin: ${({ padding }) => `${padding?.top ?? 0} ${padding?.right ?? 0} ${padding?.bottom ?? 0} ${padding?.left ?? 0}`};
	a {
		color: ${({ theme }) => theme.color.prune};
	}
	> ul > li {
		margin: 1rem 0;
	}
`;

const HtmlParser = ({ children, padding }: { children: any, padding?: { top?: string; right?: string; bottom?: string; left?: string } }) => {

	return (
		<HtmlParserContainer padding={padding} className='ck-content'>
			{parse(DOMPurify.sanitize(children))}
		</HtmlParserContainer>
	);
};

export default HtmlParser;
